
import { defineComponent, onMounted, reactive } from "vue";
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb";
import { MenuComponent } from "@/assets/ts/components";
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import ApiService from "@/core/services/ApiService";
import { ErrorMessage, Field, Form } from "vee-validate";

import { useToast } from "vue-toastification";
import { useRouter, useRoute } from "vue-router";
import { ref } from "yup";
import { useStore } from "vuex";
import { Actions } from "@/store/enums/StoreEnums";

export default defineComponent({
  name: "kt-widget-11",
  components: {
    Field,
  },
  props: {
    widgetClasses: String,
  },

  data() {
    return {
      tableData: [],
      detail: {
        name: "",
        picBranch: "",
        note: "",
        email: "",
        phone: "",
        address: {
          province: "",
          city: "",
          regency: "",
          detail: "",
        },
      },
      paging: {
        page: 0,
        totalPages: 0,
        size: 10,
        totalElements: 0,
        perPageOptions: [10, 25, 50, 100],
      },

      branchName: "",
    };
  },

  beforeMount() {
    const store = useStore();

    store.dispatch(Actions.VERIFY_AUTH_BANK);

    this.getIdArea();

    // this.getData(this.paging.size, this.paging.page);

    setCurrentPageBreadcrumbs("Detail Cabang", ["Data"]);
  },

  computed: {
    to() {
      let highBound = this.from + this.paging.size;
      if (this.paging.totalElements < highBound) {
        highBound = this.paging.totalElements;
      }
      return highBound;
    },
    from() {
      return this.paging.size * this.paging.page;
    },
  },

  methods: {
    getIdArea() {
      const toast = useToast();
      const $route = useRoute();

      ApiService.getWithoutSlug(
        "crmv2/main_bank/bank/office/area/branch/" +
          this.$route.params.idBank +
          "/" +
          this.$route.params.idArea +
          "/" +
          this.$route.params.idBranch
      )
        .then((res) => {
          this.detail.name = res.data.area[0].branch[0].name;
          this.detail.picBranch = res.data.area[0].branch[0].picBranch;
          this.detail.note = res.data.area[0].branch[0].note;
          this.detail.email = res.data.area[0].branch[0].email;
          this.detail.phone = res.data.area[0].branch[0].phone;
          this.detail.address.province =
            res.data.area[0].branch[0].address.province;
          this.detail.address.city = res.data.area[0].branch[0].address.city;
          this.detail.address.regency =
            res.data.area[0].branch[0].address.regency;
          this.detail.address.detail =
            res.data.area[0].branch[0].address.detail;
        })
        .catch((e) => {
          toast.error(e.res.data.detail);
        });
    },

    getData(size, page) {
      let search = "?";
      if (this.branchName) {
        search = "branchName=" + this.branchName + "&";
      } else {
        search;
      }

      ApiService.getWithoutSlug(
        "crmv2/main_bank/bank/office/area/branch/all/" +
          this.$route.params.idBank +
          "/" +
          this.$route.params.idArea +
          search +
          "page=" +
          page +
          "&size=" +
          size +
          "&sort=branchName&dir=1"
      )
        .then(({ data }) => {
          this.tableData = data.content;
          this.paging.page = data.page;
          this.paging.size = data.size;
          this.paging.totalElements = data.totalElements;
          this.paging.totalPages = data.totalPages;
        })
        .catch(({ response }) => {});
    },

    handleDelete(index, item) {
      Swal.fire({
        title: "Apakah Anda Yakin ?",
        text: `Data yang telah dihapus tidak dapat dikembalikan !`,
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "btn btn-success btn-fill",
        cancelButtonClass: "btn btn-danger btn-fill",
        confirmButtonText: "Ya, hapus !",
        cancelButtonText: "Batal",
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.deleteRow(item);
        }
      });
    },
    deleteRow(item) {
      const toast = useToast();
      const $route = useRoute();

      ApiService.delete(
        "crmv2/main_bank/bank/office/area/branch/" +
          $route.params.idBank +
          "/" +
          $route.params.idArea +
          "/" +
          item.branchId
      )
        .then((res) => {
          toast.success("Hapus Berhasil");

          this.getData(this.paging.size, this.paging.page);
        })

        .catch((error) => {
          toast.error("Gagal Hapus");
        });
    },

    range(min, max) {
      const arr: any[] = [];
      for (let i = min; i <= max; i++) {
        arr.push(i);
      }
      return arr;
    },

    changePage(item) {
      const page = item - 1;
      this.getData(this.paging.size, page);
    },
    nextPage() {
      const page = this.paging.page + 1;
      this.getData(this.paging.size, page);
    },
    prevPage() {
      const page = this.paging.page - 1;
      this.getData(this.paging.size, page);
    },
    changePageSize(e) {
      const page = this.paging.page;
      this.getData(this.paging.size, page);
    },
  },
});
